import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import createPersistedState from 'vuex-persistedstate'
import localStorage from './plugins/localstorage'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    notifications: [],
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    drawer: null,
    dark: false,
    hideDrawer: false,
    scannedPackages: [],
    carriers: [],
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => localStorage.get(key),
        setItem: (key, value) => localStorage.set(key, value),
        removeItem: key => localStorage.remove(key),
      },
    }),
  ],
  mutations: {
    SET_CARRIERS (state, payload) {
      state.carriers = payload
    },
    SET_HIDE_DRAWER (state, payload) {
      state.hideDrawer = payload
    },
    SET_DARK_MODE (state, payload) {
      state.dark = !state.dark
    },
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    SET_NOTIFICATIONS (state, payload) {
      state.notifications = payload
    },
    ADD_NOTIFICATION (state, payload) {
      const notifications = [...state.notifications]
      if (payload.key) {
        const index = _.findIndex(state.notifications, ['key', payload.key])
        if (index > -1) { notifications.splice(index, 1, payload) } else notifications.push(payload)
      } else { notifications.push(payload) }

      state.notifications = notifications
    },
    REMOVE_NOTIFICATION (state, payload) {
      const notifications = state.notifications
      notifications.splice(payload, 1)
      state.notifications = notifications
    },
    SAVE_SCANNED_PACKAGE (state, payload) {
      const packages = [...state.scannedPackages]
      packages.push(payload)
      state.scannedPackages = packages
    },
    REMOVE_OLD_PACKAGES (state, payload) {
      const d = moment(payload)
      const packages = [...state.scannedPackages]
      for (var i = 0; i < packages.length; i++) {
        if (moment(d).diff(packages[i].date, 'days') >= 3) {
            packages.splice(i, 1)
        }
    }
    state.scannedPackages = packages
    },

  },
  actions: {

  },
 })
